import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/Automation`,
  scopes: ExtHubRequest,
});
const phoneAPI = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/Phone`,
  scopes: ExtHubRequest,
});

phoneAPI.createEntities([{ name: 'getPolicyByPhone' }]);
api.createEntities([{ name: 'GetTransactionSteps' }]);

const GetTransactionSteps = (transaction) =>
  api.endpoints.GetTransactionSteps.post(transaction.TransactionID);
const getPolicyByPhone = (body) => phoneAPI.endpoints.getPolicyByPhone.post(body);

export { GetTransactionSteps, getPolicyByPhone };
